





























































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {CertificateModel} from '@/models/certificate.model';

@Component({
  components: {},
})
export default class CollaborationCertificate extends Vue {
  @Prop({required: true}) certificate!: CertificateModel;
  @Prop({required: false, default: true}) showDownloadButton!: boolean;
  @Prop({required: false, default: false}) flat!: boolean;

  createUrlVerifyCertificate() {
    return `${window.location.host}/certificate/${this.certificate.verify_code}`;
  }
}
